import { render, staticRenderFns } from "./RecipeStep1.vue?vue&type=template&id=42077f14&scoped=true"
import script from "./RecipeStep1.vue?vue&type=script&lang=js"
export * from "./RecipeStep1.vue?vue&type=script&lang=js"
import style0 from "./RecipeStep1.vue?vue&type=style&index=0&id=42077f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42077f14",
  null
  
)

export default component.exports